import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

import UserLayout from './components/UserLayout';
import NoInternetScreen from './components/NoInternetScreen';
import HomePage from './pages/HomePage';
import QuiSommesNousPage from './pages/QuiSommesNousPage';
import RepresentationsPage from './pages/RepresentationsPage';
import SemencePage from './pages/SemencePage';
import EnseignementsPage from './pages/EnseignementsPage';
import TemoignagesPage from './pages/TemoignagesPage';
import PrieresPage from './pages/PrieresPage';
import MotivationPage from './pages/MotivationPage';
import EvenementsPage from './pages/EvenementsPage';
import CanauxPage from './pages/CanauxPage';
import DirectsPage from './pages/DirectsPage';
import ContactPage from './pages/ContactPage';
import PosterDetailPage from './components/VenuePage';
import PageDetailPage from './pages/PageDetailPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';

export default function App() {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (!isOnline) return <NoInternetScreen />;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* All other pages share UserLayout */}
        <Route element={<UserLayout />}>
          <Route path="/qui-sommes-nous" element={<QuiSommesNousPage />} />
          <Route path="/representations" element={<RepresentationsPage />} />
          <Route path="/semence" element={<SemencePage />} />
          <Route path="/enseignements" element={<EnseignementsPage />} />
          <Route path="/temoignages" element={<TemoignagesPage />} />
          <Route path="/prieres" element={<PrieresPage />} />
          <Route path="/motivation" element={<MotivationPage />} />
          <Route path="/evenements" element={<EvenementsPage />} />
          <Route path="/evenements/:id" element={<PosterDetailPage />} />
          <Route path="/canaux" element={<CanauxPage />} />
          <Route path="/directs" element={<DirectsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/pages/:slug" element={<PageDetailPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
